import api from "src/apis/api"

// Projects → towers → units (reused inventory endpoints).
export async function fetchProjects() {
  const { data } = await api.get("/api/v1/projects")
  return data
}

export async function fetchTowers(projectId) {
  const { data } = await api.get(`/api/v1/projects/${projectId}/towers`)
  return data
}

export async function fetchUnits(projectId, { tower_id = "" } = {}) {
  const params = new URLSearchParams()
  if (tower_id) params.set("tower_id", tower_id)
  const { data } = await api.get(`/api/v1/projects/${projectId}/units?${params}`)
  return data
}

// Save a construction-linked plan onto a single unit.
export async function configureUnitClp(projectId, unitId, { milestones, plan_name }) {
  const { data } = await api.post(
    `/api/v1/projects/${projectId}/units/${unitId}/configure_clp`,
    { milestones, plan_name }
  )
  return data
}

// Apply a plan to every unit in a tower. mode: "fill_only" | "overwrite".
export async function applyTowerClp(projectId, towerId, { milestones, mode, plan_name }) {
  const { data } = await api.post(
    `/api/v1/projects/${projectId}/towers/${towerId}/apply_clp`,
    { milestones, mode, plan_name }
  )
  return data
}

export async function fetchPaymentPlans() {
  const { data } = await api.get("/api/v1/payment_plans")
  return data
}
